<router-outlet></router-outlet>
<app-toast-container></app-toast-container>
<app-vault-notice-host></app-vault-notice-host>
<app-vault-confirm-dialog></app-vault-confirm-dialog>
